export class AppConsts {
    static GRID_DEFAULT_PAGE_SIZE = 10;
    static GRID_DEFAULT_PAGE_NUMBER = 1;
}
